<div>
    <span class="font-semibold text-2xl pt-2">Administrar Piezas para lote: {{numeroRegistro}}</span>
    <hr class="my-4">

    <form #myForm="ngForm">
        <div class="flex-1 flex flex-col text-xs md:text-sm">
        <label class="flex items-center py-1 text-xs md:text-md font-semibold"
            >Descripción*</label>
        <textarea
        [(ngModel)]="dataForm.descripcion"
        name="descripcion" 
        id="descripcion" 
        rows="4" 
        required
        class="flex-1 p-2 border-2 text-sm md:text-md leading-normal" 
        placeholder="Descripción"></textarea>
    </div>

    <div class="w-full grid gap-3 mt-3 grid-cols-1 md:grid-cols-2 items-center">
        <mat-form-field class="w-full fuse-mat-dense">
            <mat-label>Numeral</mat-label>
            <input matInput type="text" id="numeral" name="numeral" placeholder="numeral"
                [(ngModel)]="dataForm.numeral" required />
        </mat-form-field>

        <button mat-raised-button 
                class="w-full rounded-sm h-[56px]"
                [color]="'primary'" 
                [disabled]="!myForm.valid"
                (click)="actualizarPieza ? actualizarPiezasBienCultural() : postPiezas()">
            {{actualizarPieza ? 'Actualizar' : 'Guardar'}} 
        </button>

    </div>


    </form>

    @if(piezas$ | async; as piezas) {
        
        <table mat-table [dataSource]="piezas"  class="w-full">
            <!-- Numeral Column -->
            <ng-container matColumnDef="numeral">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                    Numeral
                </th>
                <td mat-cell *matCellDef="let pieza" class="border-r"> {{pieza.numeral}} </td>
            </ng-container>

            <!-- Nombre Column -->
            <ng-container matColumnDef="descripcion">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                    Descripción
                </th>
                <td mat-cell *matCellDef="let pieza" class="border-r"> {{pieza.descripcion}} </td>
            </ng-container>

            <!-- acciones Column -->
            <ng-container matColumnDef="acciones">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                </th>
                <td mat-cell *matCellDef="let pieza" class="flex justify-center items-center gap-2">
                    <button mat-icon-button (click)="editPiezaBienCultural(pieza)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deletePiezaBienCultural(pieza.piezaId)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-300 h-10"></tr>
            <tr mat-row *matRowDef="let row; columns:displayedColumns;" class="border h-10"></tr>
        </table>
    }

    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-raised-button
            class="rounded-sm w-full"  
            [color]="'secondary'"
            (click)="this.dialogRef.close(false)">
            Cancelar
        </button>

        <button mat-raised-button 
            [color]="'primary'" 
            class="rounded-sm w-full"
            type="submit"
             (click)="this.dialogRef.close(false)"
            >Aceptar
        </button>
    </div>

    

</div>